
import logo from '../../assets/images/logo.png';
import profile1 from '../../assets/images/users/01.jpg';
import profile2 from '../../assets/images/users/02.jpg';
import profile3 from '../../assets/images/users/03.jpg';
import profile4 from '../../assets/images/users/04.jpg';
import profile5 from '../../assets/images/users/05.jpg';
import profile6 from '../../assets/images/users/06.jpg';
import profile7 from '../../assets/images/users/07.jpg';
import profile8 from '../../assets/images/users/08.jpg';
import profile12 from '../../assets/images/users/12.jpg';
import profile13 from '../../assets/images/users/13.jpg';
import notfound from '../../assets/images/users/notfound.png';

import msg01 from '../../assets/images/msg/01.png';
import msg02 from '../../assets/images/msg/02.png';
import msg03 from '../../assets/images/msg/03.png';
import msg04 from '../../assets/images/msg/04.png';
import msg05 from '../../assets/images/msg/05.png';
import msg06 from '../../assets/images/msg/06.png';
import msg07 from '../../assets/images/msg/07.png';
import msg08 from '../../assets/images/msg/08.png';
import msg09 from '../../assets/images/msg/09.png';
import msg10 from '../../assets/images/msg/10.png';
import msg11 from '../../assets/images/msg/11.png'; 
import imgprivacy from '../../assets/images/users/img-privacy.jpg';
import titlebg from '../../assets/images/title-bg.jpg';
import loginbg from '../../assets/images/loginbg.jpg';
import loginbg1 from '../../assets/images/loginbg1.jpg';

import googleadd from '../../assets/images/google-add.jpg';
import authorimg from '../../assets/images/author-img.jpg';
import gad3 from '../../assets/images/gad-3.jpg';


import openjobs from '../../assets/images/openjobs.png';
import mail from '../../assets/images/mail.png';
import followers from '../../assets/images/followers.png';
 


 
    const Profiles = { logo,
        profile1, 
        profile2, 
        profile3, 
        profile4, 
        profile5, 
        profile6, 
        profile7, 
        profile8, 
        profile12,notfound,
        msg01,msg02,msg03,msg04,msg05,msg06,msg07,msg08,msg09,msg10,msg11,
        profile13,imgprivacy,titlebg,loginbg,googleadd,authorimg,gad3,
        followers,mail,openjobs,loginbg1
     }; 
     
export default Profiles;